import { createContext, useContext } from "react";

/**
 * Auth Context
 * Manages global authentication state
 */
export const AuthContext = createContext({
  // User state
  user: null,
  isAuthenticated: false,
  isLoading: true,

  // Auth methods
  login: async () => {},
  register: async () => {},
  logout: async () => {},
  updateProfile: async () => {},
  changePassword: async () => {},

  // Token management
  token: null,
  checkAuth: async () => {},
});

/**
 * Custom hook to use Auth Context
 * @returns {Object} Auth context value
 *
 * @example
 * const { user, isAuthenticated, login, logout } = useAuth();
 */
export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used within AuthProvider");
  }

  return context;
};

